import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../../models';
import { TREE_METRIC_EVENT } from 'app/AppConstant';

@Component({
  selector: 'app-tree-row-value',
  templateUrl: './tree-row-value.component.html',
  styleUrls: ['./tree-row-value.component.scss']
})

export class TreeRowValueComponent {
  @Input() node: TreeNode;
  @Input() value: string;
  @Input() timestamp: number;
  @Input() valDisplayType: string;
  @Output() eventTriggered = new EventEmitter<string>();

  readonly treeMetricEvents = TREE_METRIC_EVENT;
  constructor() {
    if (this.value === 'null') {
      this.value = '';
    }

    if (this.node?.data?.displayVal['value'] === 'null') {
      this.node.data.displayVal['value'] = '';
    }
  }

  ngOnInit() {}

  triggerEvent(value: boolean) {
    if (value) {
      console.log('value:triggerEvent ', value);
      this.eventTriggered.emit(this.node?.label);
    }
  }
}